import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaUser, FaEnvelope, FaPhone, FaShieldAlt } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import "../styles/MonCompte.css";

const MonCompte = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserName(decoded.email || "");
      } catch (err) {
        console.error("Erreur de décodage du token :", err);
      }
    }

    const storedUser = localStorage.getItem("user");
    try {
      if (storedUser && storedUser !== "undefined") {
        setUserData(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("Erreur de parsing des données utilisateur :", err);
    }
  }, []);

  const { nom = '', prenom = '', email = '', phone = '', role = '' } = userData || {};

  return (
    <div className="mon-compte-page">
      <div className="mon-compte-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Retour
        </button>
        <h1>Mon compte</h1>
      </div>

      <div className="mon-compte-content">
        <div className="mon-compte-card">
          <div className="account-avatar-section">
            <div className="account-avatar">
              {prenom && nom ? (
                <span>{prenom.charAt(0)}{nom.charAt(0)}</span>
              ) : (
                <FaUser />
              )}
            </div>
            <div className="account-name">
              <h2>{prenom} {nom}</h2>
              <span className="account-role">{role || "Admin"}</span>
            </div>
          </div>

          <div className="account-info-grid">
            <div className="account-info-item">
              <div className="info-icon"><FaUser /></div>
              <div className="info-content">
                <span className="info-label">Nom</span>
                <span className="info-value">{nom || "—"}</span>
              </div>
            </div>

            <div className="account-info-item">
              <div className="info-icon"><FaUser /></div>
              <div className="info-content">
                <span className="info-label">Prénom</span>
                <span className="info-value">{prenom || "—"}</span>
              </div>
            </div>

            <div className="account-info-item">
              <div className="info-icon"><FaEnvelope /></div>
              <div className="info-content">
                <span className="info-label">Email</span>
                <span className="info-value">{email || userName || "—"}</span>
              </div>
            </div>

            <div className="account-info-item">
              <div className="info-icon"><FaPhone /></div>
              <div className="info-content">
                <span className="info-label">Téléphone</span>
                <span className="info-value">{phone || "—"}</span>
              </div>
            </div>

            <div className="account-info-item">
              <div className="info-icon"><FaShieldAlt /></div>
              <div className="info-content">
                <span className="info-label">Rôle</span>
                <span className="info-value">{role || "Admin"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonCompte;
